import React from "react";
import { Button, Input, Card } from "antd";
import { TeamMember } from "../../../types/admin/TeamTypes";

interface EducationTabProps {
	teamMember: TeamMember;
	setTeamMember: React.Dispatch<React.SetStateAction<any>>;
}

interface EducationEntry {
	degree: string;
	institution: string;
	year: string;
}

const EducationTab: React.FC<EducationTabProps> = ({ teamMember, setTeamMember }) => {
	const educationHistory: EducationEntry[] =
		teamMember.team_member_info?.education_history || [];

	const handleEducationChange = (index: number, field: keyof EducationEntry, value: string) => {
		setTeamMember((prev: TeamMember) => {
			const updated = [...(prev.team_member_info?.education_history || [])];
			updated[index] = { ...updated[index], [field]: value };
			return {
				...prev,
				team_member_info: { ...prev.team_member_info, education_history: updated },
			};
		});
	};

	const addEducationEntry = () => {
		setTeamMember((prev: TeamMember) => ({
			...prev,
			team_member_info: {
				...prev.team_member_info,
				education_history: [
					...(prev.team_member_info?.education_history || []),
					{ degree: "", institution: "", year: "" },
				],
			},
		}));
	};

	const removeEducationEntry = (index: number) => {
		setTeamMember((prev: TeamMember) => ({
			...prev,
			team_member_info: {
				...prev.team_member_info,
				education_history: (prev.team_member_info?.education_history || []).filter(
					(_: any, idx: number) => idx !== index
				),
			},
		}));
	};

	return (
		<div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
			{educationHistory.map((entry, index) => (
				<Card
					key={index}
					size="small"
					title={`Education ${index + 1}`}
					extra={
						<Button danger size="small" onClick={() => removeEducationEntry(index)}>
							Remove
						</Button>
					}
				>
					<div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
						<div>
							<label style={{ display: "block", marginBottom: 4, fontSize: 13 }}>Degree</label>
							<Input
								value={entry.degree}
								onChange={(e) => handleEducationChange(index, "degree", e.target.value)}
								placeholder="e.g. Bachelor of Medicine"
							/>
						</div>
						<div>
							<label style={{ display: "block", marginBottom: 4, fontSize: 13 }}>Institution</label>
							<Input
								value={entry.institution}
								onChange={(e) => handleEducationChange(index, "institution", e.target.value)}
								placeholder="e.g. University of Melbourne"
							/>
						</div>
						<div>
							<label style={{ display: "block", marginBottom: 4, fontSize: 13 }}>Year</label>
							<Input
								value={entry.year}
								onChange={(e) => handleEducationChange(index, "year", e.target.value)}
								placeholder="e.g. 2015"
							/>
						</div>
					</div>
				</Card>
			))}

			<Button
				type="dashed"
				onClick={addEducationEntry}
				style={{ width: "100%" }}
			>
				+ Add Education Entry
			</Button>
		</div>
	);
};

export default EducationTab;
